import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-plan-expired',
  templateUrl: './plan-expired.component.html',
  styleUrls: ['./plan-expired.component.scss'],
})
export class PlanExpiredComponent {
  @Input() update: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    this.update = false;
  }

  logout(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('session');
      localStorage.removeItem('token');
      localStorage.removeItem('expires_at');
      window.location.reload();
    }
  }
}
